export const navigation = {
  is: {
	home: "Heim",
	company: "Fyrirtækið",
	services: "Þjónusta",
	solutions: "Lausnir",
	projects: "Verkefni",
	contact: "Hafa samband",
	pricing: "Verðskrá",
	servicePackages: "Þjónustupakkar",
	serviceDesk: "Þjónustuborð",
  GetQuote: "FÁ TILBOÐ",
	news: "Fréttir",
	services: {
	  title: "Þjónusta",
	  description: "Sérsniðnar lausnir sem henta þínum þörfum",
	  webDevelopment: {
		title: "Vefsíðugerð",
		description: "Sérsniðnar veflausnir sem skila árangri"
	  },
	  webDesign: {
		title: "Vefhönnun",
		description: "Nútímaleg hönnun sem fangar athygli"
	  },
	  webProgramming: {
		title: "Vefþróun",
		description: "Öflug og skilvirk forritun"
	  },
	  consulting: {
		title: "Ráðgjöf",
		description: "Fagleg ráðgjöf og stefnumótun"
	  },
	  marketing: {
		title: "Markaðssetning",
		description: "Markviss stafræn markaðssetning"
	  },
	  seo: {
		title: "Leitarvélabestun",
		description: "SEO þjónusta sem skilar árangri"
	  },
	  analytics: {
		title: "Greiningar",
		description: "Skýrslur og greiningar"
	  },
	  maintenance: {
		title: "Viðhald",
		description: "Örugg þjónusta og viðhald"
	  }
	},
	solutions: {
	  title: "Lausnir",
	  description: "Sérhannaðar lausnir fyrir þitt fyrirtæki",
	  ai: {
		title: "Gervigreind",
		description: "AI lausnir fyrir fyrirtæki"
	  },
	  booking: {
		title: "Bókunarkerfi",
		description: "Sjálfvirk bókunarkerfi"
	  },
	  subscription: {
		title: "Áskriftarkerfi",
		description: "Recurring revenue lausnir"
	  },
	  ecommerce: {
		title: "Netverslun",
		description: "WooCommerce / Shopify"
	  },
	  pos: {
		title: "Kassakerfi",
		description: "POS lausnir"
	  },
	  wordpress: {
		title: "WordPress",
		description: "WordPress lausnir"
	  },
	  wordpressExpress: {
		title: "WordPress Express",
		description: "Hraðvirk WordPress lausn"
	  },
	  hosting: {
		title: "Vefhýsing",
		description: "Örugg hýsing"
	  },
	  email: {
		title: "Tölvupóstur",
		description: "Tölvupóstþjónusta"
	  },
	  management: {
		title: "Vefumsjón",
		description: "Viðhald og öryggi"
	  },
	  chat: {
		title: "Netspjall",
		description: "AI spjallmenni"
	  }
	}
  },
  en: {
	home: "Home",
	company: "Company",
	services: "Services",
	solutions: "Solutions",
	projects: "Projects",
	contact: "Contact",
	pricing: "Pricing",
	servicePackages: "Service Packages",
	serviceDesk: "Service Desk",
  GetQuote: "GET QUOTE",
	news: "News",
	services: {
	  title: "Services",
	  description: "Custom solutions tailored to your needs",
	  webDevelopment: {
		title: "Web Development",
		description: "Custom web solutions that deliver results"
	  },
	  webDesign: {
		title: "Web Design",
		description: "Modern design that captures attention"
	  },
	  webProgramming: {
		title: "Web Programming",
		description: "Powerful and efficient programming"
	  },
	  consulting: {
		title: "Consulting",
		description: "Professional consulting and strategy"
	  },
	  marketing: {
		title: "Marketing",
		description: "Targeted digital marketing"
	  },
	  seo: {
		title: "SEO",
		description: "SEO services that deliver results"
	  },
	  analytics: {
		title: "Analytics",
		description: "Reports and analytics"
	  },
	  maintenance: {
		title: "Maintenance",
		description: "Secure service and maintenance"
	  }
	},
	solutions: {
	  title: "Solutions",
	  description: "Custom solutions for your business",
	  ai: {
		title: "AI Solutions",
		description: "AI solutions for businesses"
	  },
	  booking: {
		title: "Booking System",
		description: "Automated booking systems"
	  },
	  subscription: {
		title: "Subscription System",
		description: "Recurring revenue solutions"
	  },
	  ecommerce: {
		title: "E-commerce",
		description: "WooCommerce / Shopify"
	  },
	  pos: {
		title: "POS System",
		description: "POS solutions"
	  },
	  wordpress: {
		title: "WordPress",
		description: "WordPress solutions"
	  },
	  wordpressExpress: {
		title: "WordPress Express",
		description: "Fast WordPress solution"
	  },
	  hosting: {
		title: "Hosting",
		description: "Secure hosting"
	  },
	  email: {
		title: "Email",
		description: "Email service"
	  },
	  management: {
		title: "Management",
		description: "Maintenance and security"
	  },
	  chat: {
		title: "Live Chat",
		description: "AI chatbot"
	  }
	}
  },
  es: {
	home: "Inicio",
	company: "Empresa",
	services: "Servicios",
	solutions: "Soluciones",
	projects: "Proyectos",
	contact: "Contacto",
	pricing: "Precios",
	servicePackages: "Paquetes de Servicio",
	serviceDesk: "Soporte",
  GetQuote: "Solicitar",
	news: "Noticias",
	services: {
	  title: "Servicios",
	  description: "Soluciones personalizadas adaptadas a tus necesidades",
	  webDevelopment: {
		title: "Desarrollo Web",
		description: "Soluciones web personalizadas que entregan resultados"
	  },
	  webDesign: {
		title: "Diseño Web",
		description: "Diseño moderno que captura la atención"
	  },
	  webProgramming: {
		title: "Programación Web",
		description: "Programación potente y eficiente"
	  },
	  consulting: {
		title: "Consultoría",
		description: "Consultoría profesional y estrategia"
	  },
	  marketing: {
		title: "Marketing",
		description: "Marketing digital dirigido"
	  },
	  seo: {
		title: "SEO",
		description: "Servicios SEO que entregan resultados"
	  },
	  analytics: {
		title: "Analítica",
		description: "Informes y análisis"
	  },
	  maintenance: {
		title: "Mantenimiento",
		description: "Servicio y mantenimiento seguro"
	  }
	},
	solutions: {
	  title: "Soluciones",
	  description: "Soluciones personalizadas para tu empresa",
	  ai: {
		title: "Inteligencia Artificial",
		description: "Soluciones de IA para empresas"
	  },
	  booking: {
		title: "Sistema de Reservas",
		description: "Sistemas de reservas automatizados"
	  },
	  subscription: {
		title: "Sistema de Suscripción",
		description: "Soluciones de ingresos recurrentes"
	  },
	  ecommerce: {
		title: "Comercio Electrónico",
		description: "WooCommerce / Shopify"
	  },
	  pos: {
		title: "Sistema POS",
		description: "Soluciones POS"
	  },
	  wordpress: {
		title: "WordPress",
		description: "Soluciones WordPress"
	  },
	  wordpressExpress: {
		title: "WordPress Express",
		description: "Solución WordPress rápida"
	  },
	  hosting: {
		title: "Hosting",
		description: "Hosting seguro"
	  },
	  email: {
		title: "Correo Electrónico",
		description: "Servicio de email"
	  },
	  management: {
		title: "Gestión",
		description: "Mantenimiento y seguridad"
	  },
	  chat: {
		title: "Chat en Vivo",
		description: "Chatbot con IA"
	  }
	}
  },
  da: {
	home: "Hjem",
	company: "Virksomhed",
	services: "Tjenester",
	solutions: "Løsninger",
	projects: "Projekter",
	contact: "Kontakt",
	pricing: "Priser",
	servicePackages: "Servicepakker",
	serviceDesk: "Servicedesk",
  GetQuote: "Få tilbud",
	news: "Nyheder",
	services: {
	  title: "Tjenester",
	  description: "Skræddersyede løsninger tilpasset dine behov",
	  webDevelopment: {
		title: "Webudvikling",
		description: "Skræddersyede webløsninger der leverer resultater"
	  },
	  webDesign: {
		title: "Webdesign",
		description: "Moderne design der fanger opmærksomheden"
	  },
	  webProgramming: {
		title: "Webprogrammering",
		description: "Kraftfuld og effektiv programmering"
	  },
	  consulting: {
		title: "Rådgivning",
		description: "Professionel rådgivning og strategi"
	  },
	  marketing: {
		title: "Marketing",
		description: "Målrettet digital marketing"
	  },
	  seo: {
		title: "SEO",
		description: "SEO-tjenester der leverer resultater"
	  },
	  analytics: {
		title: "Analyse",
		description: "Rapporter og analyser"
	  },
	  maintenance: {
		title: "Vedligeholdelse",
		description: "Sikker service og vedligeholdelse"
	  }
	},
	solutions: {
	  title: "Løsninger",
	  description: "Skræddersyede løsninger til din virksomhed",
	  ai: {
		title: "Kunstig Intelligens",
		description: "AI-løsninger til virksomheder"
	  },
	  booking: {
		title: "Bookingsystem",
		description: "Automatiserede bookingsystemer"
	  },
	  subscription: {
		title: "Abonnementssystem",
		description: "Løsninger til tilbagevendende omsætning"
	  },
	  ecommerce: {
		title: "E-handel",
		description: "WooCommerce / Shopify"
	  },
	  pos: {
		title: "POS-system",
		description: "POS-løsninger"
	  },
	  wordpress: {
		title: "WordPress",
		description: "WordPress-løsninger"
	  },
	  wordpressExpress: {
		title: "WordPress Express",
		description: "Hurtig WordPress-løsning"
	  },
	  hosting: {
		title: "Hosting",
		description: "Sikker hosting"
	  },
	  email: {
		title: "Email",
		description: "Email-service"
	  },
	  management: {
		title: "Administration",
		description: "Vedligeholdelse og sikkerhed"
	  },
	  chat: {
		title: "Live Chat",
		description: "AI chatbot"
	  }
	}
  }
};